// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__31oiz","row":"ProcedureTreatmentSummary_row__2kLy8"};